import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import "./DialogFollowup.scss";
import Translated from "../../../components/Translated/Translated";

function DialogFollowup(props) {
	const [open, setOpen] = React.useState(false);
	const [response, setResponse] = React.useState({});
	const [email, setEmail] = React.useState("");
	const [date, setDate] = React.useState("");

	async function handleClose() {
		setOpen(false);
	}

	async function handleClickOpen() {
		let ajaxURL = props.APIUrl + "/emco_quotes/followup?project_id=" + props.projectId +"&consultant_id=" + localStorage.getItem("trendId");

		let APIResponse = await Axios.get(ajaxURL);
		console.log("here is the value for the api response ", APIResponse)
		if (APIResponse.data) {
			setEmail(APIResponse.data.consultant_email);
			let new_date = APIResponse.data.followup_date ? new Date(APIResponse.data.followup_date) : new Date();
			setDate(new_date.toISOString().split("T")[0]);
		}
		setResponse({});
		setOpen(true);
	}

	async function submit() {
		let ajaxURL = props.APIUrl + "/emco_quotes/followup";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId,
			date: date,
			email: email
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		setResponse(APIResponse.data);
		return;
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="quote-dialog-info">
					<div><Translated section="Followup" label="followup_dialog_message" /></div>
					<div><Translated section="Followup" label="followup_dialog_message_2" /></div>
				</div>
				<div class="followup-input">
					<div class="followup-label"><Translated section="Followup" label="followup_date_label" /></div>
					<input value={date} type="date" placeholder="Select followup date" onChange={e => setDate(e.target.value)} />
				</div>
				<div class="followup-input">
					<div class="followup-label"><Translated section="Followup" label="followup_email_label" /></div>
					<input value={email} type="email" placeholder="email@website.com" onChange={e => setEmail(e.target.value)} />
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="quote-nav-component">
			<button onClick={handleClickOpen} class="quote-nav-top-link">
				<div></div>
				<div><Translated section="Followup" label="followup_dialog_title" /></div>
			</button>
			<Dialog open={open} onClose={handleClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Followup" label="followup_dialog_title" /></div>

					{hasResponse ? responseBody() : formBody()}

					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}>
							<Translated section="Misc" label="close_btn" />
						</button>
						{hasResponse ? (
							""
						) : (
								<button class="quote-dialog-button" onClick={submit}>
									<Translated section="Misc" label="ok_btn" />
							</button>
							)}
					</div>
				</div>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialogFollowup);
